<template>
    <div class="m-welfare">
        <h5 class="title"></h5>

        <div class="welfare-view" v-if="$store.state.task.length">
            <div class="view-item">
                <h6 class="title t-1"></h6>

                <div class="box">
                    <div class="layer-box p-1"></div>
                </div>

                <div class="reward-list">
                    <div class="reward-item" v-for="(item,index) in pack_config['box_1']" :key="index"  @click="$item_tips(item.id)">
                        <game-item :id="item.id" :num="item.num" :locked="true"></game-item>
                    </div>
                </div>

                <p class="notice">所有玩家登录绑定后每周可领一次<br/>（未领取的奖励可累积到下一周）</p>

                <div class="u-btn apply disabled" v-if="$store.state.userinfo.areaId && ($store.state.task[2].giftRate == $store.state.task[2].finishRate)" @click="$toast('无法领取')"></div>
                <div class="u-btn apply" v-else @click="apply_pack(2)"></div>
            </div>
            <div class="view-item">
                <h6 class="title t-2"></h6>

                <div class="box">
                    <div class="layer-box p-2"></div>
                </div>

                <div class="reward-list">
                    <div class="reward-item" v-for="(item,index) in pack_config['box_2']" :key="index"  @click="$item_tips(item.id)">
                        <game-item :id="item.id" :num="item.num" :locked="true"></game-item>
                    </div>
                </div>                
                
                <p class="notice">解锁鸡王奖励后每周可领一次<br/>（未领取的奖励可累积到下一周）</p>

                <div class="u-btn apply disabled" v-if="$store.state.userinfo.areaId && ($store.state.task[3].giftRate == $store.state.task[3].finishRate)" @click="$toast('无法领取')"></div>
                <div class="u-btn apply" v-else @click="apply_pack(3)"></div>                
            </div>
        </div>
    </div>
</template>

<style scoped>
h5.title{
    width: 479px;
    height: 73px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/title-fuli.png);
}

.welfare-view{
    display: flex;
    justify-content: space-between;
}

.view-item{
    width: 353px;
    height: 589px;
    padding-top: 28px;
    background-image: url(~@/assets/images/bg-fuli-item.png);
    box-sizing: border-box;  
}

h6.t-1{
    width: 224px;
    height: 29px;
    margin: 0 auto 10px;
    background-image: url(~@/assets/images/title-fuli-1.png);
}

h6.t-2{
    width: 224px;
    height: 29px;
    margin: 0 auto 10px;
    background-image: url(~@/assets/images/title-fuli-2.png);
}

.box{
    position: relative;
    width: 161px;
    height: 161px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-fuli-box.png);
}

.layer-box{
    position: absolute;
    left: 50%;
    top: 50%;
}

.layer-box.p-1{
    width: 96px;
    height: 102px;
    margin: -51px 0 0 -48px;
    background-image: url(~@/assets/images/pack-1.png);    
}

.layer-box.p-2{
    width: 104px;
    height: 101px;
    margin: -50.5px 0 0 -52px;
    background-image: url(~@/assets/images/pack-2.png);    
}

.reward-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 10px 0 10px;
    padding: 0 80px;
}

.reward-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 84px;
    height: 84px;
    margin-bottom: 10px;
    background-image: url(~@/assets/images/bg-item.png);
}

.notice{
    font-size: 20px;
    text-align: center;
    color: #9c603a;
}

.u-btn.apply{
    width: 225px;
    height: 60px;
    margin: 12px auto 0;
    background-image: url(~@/assets/images/btn-apply.png);
}

.u-btn.apply.disabled{
    background-image: url(~@/assets/images/btn-apply-disabled.png);
}
</style>

<script>
export default {
    data (){
        return {
            pack_config : {
                'box_1' : [{name : '士兵卡',id : 'AN07',num : 2},{name : '征战印记(30天）',id : 'X230',num : 10},{name : '活跃之心',id : 'X200',num : 10},{name : '玄机之晶(30天）',id : 'Y578',num : 10}],
                'box_2' : [{name : '士兵卡',id : 'AN07',num : 4},{name : '兵粮卡',id : 'AN08',num : 4},{name : '征战印记(30天）',id : 'X230',num : 25},{name : '竞技畅玩自选礼包',id : 'KE89',num : 5}],
            },
        }
    },
    methods : {
        apply_pack(gid){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');

                return this.$bind_modal();
            }

            this.$axios.post(ajax_url_map.apply,{
                code : gid,
            })
            .then(
                res => {
                    this.$success_Apply();
                    //TODO
                    //task_update
                    let pos = gid == 2 ? 2 : 3;
                    this.$store.commit("$_setWelfareStatus", gid);  
                },
                rej => {
                    this.$toast(rej.message);
                }
            )            
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Shop/welfare.vue